import React from "react"
import { RoomProvider } from "./src/utils/RoomContext"
import { UserProvider } from "./src/utils/UserContext"

export const wrapRootElement = ({ element }) => (
  <UserProvider>
    <RoomProvider>{element}</RoomProvider>
  </UserProvider>
)
